import { render, staticRenderFns } from "./CoOrganiser.vue?vue&type=template&id=dcdc8f92&scoped=true&"
import script from "./CoOrganiser.vue?vue&type=script&lang=js&"
export * from "./CoOrganiser.vue?vue&type=script&lang=js&"
import style0 from "./CoOrganiser.vue?vue&type=style&index=0&id=dcdc8f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdc8f92",
  null
  
)

export default component.exports